/**
 * Keyboard-shortcut help modal. Listens for the `keep:show-help` window event
 * (fired by the global shortcut handler when "?" is pressed) and opens a
 * Modal listing all available shortcuts.
 */

import { useEffect, useState } from "react";
import { Modal } from "./Modal";
import { SHORTCUT_EVENTS, SHORTCUTS } from "../lib/shortcuts";

export function ShortcutsHelp() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(SHORTCUT_EVENTS.showHelp, handler);
    return () => window.removeEventListener(SHORTCUT_EVENTS.showHelp, handler);
  }, []);

  return (
    <Modal open={open} onClose={() => setOpen(false)} title="Keyboard shortcuts">
      <dl className="space-y-2 text-sm">
        {SHORTCUTS.map((s) => (
          <div key={s.description} className="flex items-center justify-between gap-4">
            <dt>{s.description}</dt>
            <dd className="flex gap-1">
              {s.keys.map((k) => (
                <kbd
                  key={k}
                  className="px-1.5 py-0.5 rounded border text-xs font-mono"
                  style={{ borderColor: "var(--border)", background: "var(--bg)" }}
                >
                  {k}
                </kbd>
              ))}
            </dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
